<template>
  <v-btn v-bind="$attrs" @click="$emit('click')">
    <v-icon v-if="icon" class="mr-2">
      {{ icon }}
    </v-icon>
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    icon: {
      type: String,
      default: undefined,
    },
  },
};
</script>
